import React, { useEffect, useState } from 'react'
import HeadSection from '../Utilities/HeadSection'
import { useDispatch, useSelector } from 'react-redux';
import { addOneBackup, getAllBackups, downloadBackup } from '../../redux/slices/backups/thunk';
import { FaArrowDown } from "react-icons/fa";
import add from "../../Images/add.png";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import Pagination from '../Utilities/Pagination';
import axios from "axios";

export default function AllBackupsComponent() {
    const dispatch = useDispatch();
    const loggedUser = JSON.parse(localStorage.getItem("user"));
    const [searchParams, setSearchParams] = useSearchParams();


    const [loading, setLoading] = useState(false);
    // add modal
    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedBackup, setSelectedBackup] = useState(null);
    const [notes, setNotes] = useState("");
    const [isNotesFocused, setIsNotesFocused] = useState(false);

    useEffect(() => {
        const get_all = async () => {
            setLoading(true);


            const queryParams = new URLSearchParams();

            queryParams.set("limit", 10);
            queryParams.set(
                "page",
                searchParams.get("page") && searchParams.get("page") !== "0"
                    ? searchParams.get("page")
                    : "1"
            );

            if (searchParams.get("type") && searchParams.get("type") !== "all") {
                queryParams.set("type", searchParams.get("type"));
            }

            if (searchParams.get("status") && searchParams.get("status") !== "all") {
                queryParams.set("status", searchParams.get("status"));
            }

            const query = queryParams.toString();

            await dispatch(getAllBackups(query));
            setLoading(false);
        };

        get_all();
    }, [searchParams]);

    const backups = useSelector((state) => state.backupsReducer.backups);

    console.log("backups", backups);

    const onSubmit = async () => {

        setLoading(true);
        const data = {
            note: notes,
            userId: loggedUser?._id
        }

        // console.log("data", data);

        // return;

        await dispatch(addOneBackup({ data }));
        await dispatch(getAllBackups());
        setLoading(false);
        setShowModal(false);
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            onSubmit();
        }
    };

    const nextPage = async (page) => {
        let next_page = page;
        searchParams.set("page", next_page);
        setSearchParams(searchParams);

    };

    const openDetailsModal = (backup) => {
        setSelectedBackup(backup);
        setShowDetailsModal(true);
    };

    const closeDetailsModal = () => {
        setSelectedBackup(null);
        setShowDetailsModal(false);
    };

    // const handleDownload = async (id, filename) => {
    //     // if (!downloadUrl) return;
    //     // https://takaful.sale/api/v1/backups/download/:id
    //     // const absoluteUrl = downloadUrl.startsWith("http")
    //     //   ? downloadUrl
    //     //   : `https://takaful.sale${downloadUrl.startsWith("/") ? "" : "/"}${downloadUrl}`;

    //     // const absoluteUrl = `https://takaful.sale/api/v1/backups/download/${id}`
    //     // const link = document.createElement("a");
    //     // link.href = absoluteUrl;
    //     // link.setAttribute("download", filename || "backup.zip");
    //     // link.setAttribute("target", "_blank");
    //     // document.body.appendChild(link);
    //     // link.click();
    //     // document.body.removeChild(link);

    //     // await dispatch(downloadBackup({id}));
    //     try {
    //         // const response = await axios.get(
    //         //     `https://takaful.sale/api/v1/backups/download/${id}`,
    //         //     {
    //         //         responseType: "blob",
    //         //     }
    //         // );
    //         // const response = await axios.get(
    //         //     `https://takaful.sale/api/v1/backups/download/${id}`,
    //         //     {
    //         //         responseType: "blob",
    //         //         headers: {
    //         //             Authorization: `Bearer ${localStorage.getItem("token")}`,
    //         //             Accept: "application/octet-stream",
    //         //         },
    //         //     }
    //         // );



    //         // const response = await axios.get(
    //         //     `https://takaful.sale/api/v1/backups/download/${id}`,
    //         //     {
    //         //          responseType: "blob",
    //         //         headers: {
    //         //             authorization: `${localStorage.getItem("token")}`,
    //         //         },
    //         //     }
    //         // );

    //         // // console.log("size", response.data.size);

    //         // console.log("is Blob?", response.data instanceof Blob);

    //         // const blob = response.data;

    //         // const url = window.URL.createObjectURL(blob);

    //         // const a = document.createElement("a");
    //         // a.href = url;
    //         // a.download = `backup-${id}.tar.gz`;

    //         // document.body.appendChild(a);
    //         // a.click();
    //         // document.body.removeChild(a);

    //         // setTimeout(() => {
    //         //     window.URL.revokeObjectURL(url);
    //         // }, 1000);

    //         const res = await fetch(
    //             `https://takaful.sale/api/v1/backups/download/${id}`,
    //             {
    //                 headers: {
    //                     authorization: localStorage.getItem("token"),
    //                 },
    //             }
    //         );

    //         console.log("res", res);
    //         if (!res.ok) {
    //             throw new Error("Network response was not ok");
    //         }

    //         // تحويل الاستجابة إلى Blob
    //         const blob = await res.blob();

    //         console.log("حجم الملف المستلم بالبايت:", blob.size);

    //         // تحويل الـ Blob إلى Base64 Data URL
    //         const reader = new FileReader();
    //         reader.onloadend = function () {
    //             const base64data = reader.result;

    //             const a = document.createElement("a");
    //             a.href = base64data;
    //             a.download = `backup-${id}.tar.gz`;

    //             document.body.appendChild(a);
    //             a.click();
    //             document.body.removeChild(a);
    //         };

    //         reader.readAsDataURL(blob);

    //         // const response = await axios.get(
    //         //     `https://takaful.sale/api/v1/backups/download/${id}`,
    //         //     {
    //         //         responseType: "text",
    //         //         headers: {
    //         //             authorization: `${localStorage.getItem("token")}`,
    //         //         },
    //         //     }
    //         // );

    //         // console.log("download response",response.data);

    //         // console.log("response", response);


    //         // const url = window.URL.createObjectURL(
    //         //     new Blob([response.data])
    //         // );

    //         // const link = document.createElement("a");
    //         // link.href = url;
    //         // link.setAttribute("download", filename || "backup.zip"); // اسم الملف

    //         // document.body.appendChild(link);
    //         // link.click();

    //         // link.remove();
    //         // window.URL.revokeObjectURL(url);
    //     } catch (error) {
    //         console.log("error download");

    //         console.error(error);
    //     }
    // };

    // const handleDownload = async (id, filename) => {
    //     try {
    //         // 1. طلب الملف باستخدام Axios مع تحديد نوع الاستجابة blob
    //         console.log("الضغط شغال! الـ ID المستلم هو:", id);
    //         const response = await axios.get(
    //             `https://takaful.sale/api/v1/backups/download/${id}`,
    //             {
    //                 responseType: "blob", // 👈 هامة جداً ليقوم أكسيوس بتحويلها تلقائياً
    //                 headers: {
    //                     authorization: localStorage.getItem("token"), // تأكد هل الباك إند يحتاج كلمة Bearer أم لا
    //                 },
    //             }
    //         );

    //         // 2. أكسيوس يضع الـ Blob المحول جاهزاً داخل response.data
    //         const blob = response.data;
    //         console.log("حجم الملف المستلم من أكسيوس:", blob.size);

    //         if (blob.size === 0) {
    //             console.error("الملف فارغ!");
    //             return;
    //         }

    //         // 3. إنشاء رابط التحميل وتفعيله
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement("a");
    //         a.href = url;
    //         // استخدم الاسم القادم من الدالة أو اسم افتراضي
    //         a.download = filename || `backup-${id}.tar.gz`;

    //         document.body.appendChild(a);
    //         a.click();

    //         // 4. تنظيف الـ DOM والذاكرة بعد التحميل
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url);

    //     } catch (error) {
    //         console.log("error download");
    //         console.error(error);
    //     }
    // };


    const handleDownload = async (id, filename) => {
        console.log("الضغط شغال! الـ ID المستلم هو:", id);

        try {
            // 1. استخدام fetch العادي مع أخذ الاستجابة كـ ArrayBuffer (أضمن وأسرع للملفات المضغوطة)
            const response = await fetch(`https://takaful.sale/api/v1/backups/download/${id}`, {
                headers: {
                    'authorization': localStorage.getItem("token")
                }
            });

            if (!response.ok) {
                console.error("السيرفر رد بخطأ:", response.status);
                return;
            }

            // 2. قراءة البيانات كـ ArrayBuffer لتجنب تعليق الـ Stream
            const buffer = await response.arrayBuffer();
            console.log("تم استلام البيانات بنجاح، الحجم:", buffer.byteLength);

            // 3. تحويل الـ Buffer إلى Blob هنا في المتصفح فوراً
            const blob = new Blob([buffer], { type: "application/gzip" });
            const url = window.URL.createObjectURL(blob);

            // 4. صناعة رابط التحميل وتفعيله
            const a = document.createElement("a");
            a.href = url;
            a.download = filename || `backup-${id}.tar.gz`;

            document.body.appendChild(a);
            a.click();

            // 5. تنظيف الذاكرة بعد ثانية لضمان بدء التحميل
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 1000);

        } catch (error) {
            console.error("حدث خطأ غير متوقع أثناء التحميل:", error);
        }
    };
    return (
        <div>
            <HeadSection label={"النسخ الاحتياطي"} />

            <div className="d-flex justify-content-between flex-wrap">
                <div>
                    <button
                        className="addButton mb-2"
                        style={{
                            backgroundColor: "#0d6efd",
                            color: "white",
                            border: "#0d6efd",
                        }}
                        onClick={() => {
                            setShowModal(true);
                        }}
                    >
                        اضافة نسخة احتياطية
                        <img
                            src={add}
                            alt=""
                            style={{
                                cursor: "pointer",
                                marginRight: "8px",
                                borderColor: "black",
                                marginTop: "auto",
                            }}
                            onClick={() => {
                                setShowModal(true);
                            }}
                        />
                    </button>
                </div>

                <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
                    <select
                        value={searchParams.get("type") || "all"}
                        onChange={(e) => {
                            if (e.target.value == "all") return;
                            searchParams.set("type", e.target.value);
                            searchParams.set("page", "1");
                            setSearchParams(searchParams);
                        }}
                    >
                        <option value="all">فلتر النوع</option>
                        <option value="manual">يدوي</option>
                        <option value="automatic">تلقائي</option>
                    </select>

                    <select
                        value={searchParams.get("status") || "all"}
                        onChange={(e) => {
                            if (e.target.value == "all") return;
                            searchParams.set("status", e.target.value);
                            searchParams.set("page", "1");
                            setSearchParams(searchParams);
                        }}
                    >
                        <option value="all">فلتر الحالة</option>
                        <option value="success">عملية ناجحة</option>
                        <option value="failed">عملية فاشلة</option>
                    </select>

                    <button
                        className="addButton mb-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            backgroundColor: "#0d6efd",
                            color: "white",
                            border: "#0d6efd",
                            height: "35px",
                        }}
                        onClick={() => {
                            setSearchParams({});
                        }}
                    >
                        الغاء الفلتر
                    </button>
                </div>

            </div>

            {/* add modal */}
            <Modal show={showModal} onHide={() => {
                setNotes("")
                setShowModal(false)
            }}>
                <Modal.Body>
                    <h5 className="h5ModalTitle">إضافة نسخة احتياطية</h5>

                    <div className="label">
                        هل تود اضافة ملاحظة مع النسخة الاحتياطية؟ (اختياري)
                    </div>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        className="w-100"
                        rows={4}
                        onKeyPress={handleKeyPress}
                        onFocus={() => setIsNotesFocused(true)}
                        onBlur={() => setIsNotesFocused(false)}
                        style={{
                            color: "#333",
                            resize: "vertical",
                            backgroundColor: "var(--background-white3)",
                            border: isNotesFocused ? "1px solid rgba(0, 128, 251, 1)" : "1px solid var(--border-color)",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            outline: "none",
                        }}
                    />


                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-center border-0">
                    <Button
                        onClick={onSubmit}
                        className="w-25"
                        variant="primary"
                        style={{ backgroundColor: "#0080FB" }}
                        disabled={loading}
                    >
                        {
                            loading ? <Spinner /> : "تم"
                        }

                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDetailsModal} onHide={closeDetailsModal}>
                <Modal.Header closeButton>
                    <Modal.Title>تفاصيل النسخة الاحتياطية</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">الاسم</label>
                        <input type="text" value={selectedBackup?.filename || ""} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">الحجم</label>
                        <input type="text" value={selectedBackup?.fileSize || ""} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">أنشئ بواسطة</label>
                        <input type="text" value={selectedBackup?.performedBy?.username || ""} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">تاريخ الإنشاء</label>
                        <input type="text" value={selectedBackup?.createdAt?.split("T")[0] || ""} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">النوع</label>
                        <input type="text" value={selectedBackup?.type === "manual" ? "يدوي" : "تلقائي"} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">الحالة</label>
                        <input type="text" value={selectedBackup?.status === "success" ? "عملية ناجحة" : "عملية فاشلة"} readOnly className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">الملاحظة</label>
                        <textarea value={selectedBackup?.note || selectedBackup?.note || "-"} readOnly className="form-control" rows={3} />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="secondary" onClick={closeDetailsModal}>إغلاق</Button>
                    <Button
                        variant="primary"
                        onClick={() => selectedBackup && handleDownload(selectedBackup._id, selectedBackup.filename)}
                        disabled={!selectedBackup || loading}
                    >
                        {loading ? <Spinner size="sm" /> : "تحميل"}
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className="permissionsTable table-responsive-wrapper" style={{ width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                <table className="responsiveTable" style={{ width: "100%", minWidth: "720px", whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th>رقم السريال</th>
                            <th>الاسم</th>
                            <th>الحجم</th>
                            <th>انشيء بواسطة</th>
                            <th>تاريخ الانشاء</th>
                            <th>النوع</th>
                            <th>الحالة</th>
                            <th>التفاصيل</th>
                        </tr>
                    </thead>
                    {backups?.backups && backups?.backups?.length > 0 ? (<tbody>


                        {backups?.backups?.map((backup, index) => (
                            <tr key={index}>
                                <td data-label="رقم السريال" style={{ color: "#FEAA00", cursor: "pointer" }}>
                                    <span
                                        // onClick={() => handleDownload(backup?._id, backup?.filename)}
                                    >{index + 1}</span>
                                </td>
                                <td data-label="الاسم">{backup?.filename}</td>
                                <td data-label="الحجم">{backup?.fileSize}</td>
                                <td data-label="انشيء بواسطة">{backup?.performedBy?.username}</td>
                                <td data-label="تاريخ الانشاء">{backup?.createdAt?.split("T")[0]}</td>
                                <td data-label="النوع">{
                                    backup?.type == "manual" ? "يدوي" : "تلقائي"
                                }</td>
                                <td data-label="الحالة">
                                    {backup?.status == "success" ? "عملية ناجحة" : "عملية فاشلة"}
                                </td>
                                <td data-label="التفاصيل"
                                    onClick={() => openDetailsModal(backup)}
                                    style={{ color: "#FEAA00", cursor: "pointer" }}
                                >
                                    تفاصيل{" "}
                                    <span>
                                        <FaArrowDown />{" "}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="100%" style={{ textAlign: "center", padding: "20px", fontSize: "18px", color: "#888" }}>
                                    لا يوجد بيانات للعرض
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>

            <div>
                <Pagination onPress={nextPage} pageCount={backups?.totalPages} />
            </div>
        </div>
    )
}
